import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";
import { getRewardsService } from "@WhiteCap/Services/GetRewardsService";

export interface RewardsModel extends BaseModel{
    accessToken:string;
}

type HandlerType = ApiHandler<{} & HasOnSuccess<RewardsModel>, RewardsModel>;


export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getRewardsService();
};


export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [
    RequestDataFromApi,
    ExecuteOnSuccessCallback,
];

const getRewards = createHandlerChainRunner(chain, "GetRewards");
export default getRewards;
